import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.find.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import jTruncate from './j-truncate.vue';
import debounce from 'quasar/src/utils/debounce.js';;
import JSkeleton from './j-skeleton.vue';
export default {
  components: {
    jTruncate: jTruncate,
    JSkeleton: JSkeleton
  },
  props: {
    selectProp: {
      type: Object,
      default: function _default() {
        return {
          key: '',
          disabled: '',
          selectable: function selectable() {
            return true;
          },
          isLine: false,
          selectAll: false
        };
      }
    },
    card: {
      type: Boolean,
      default: false
    },
    columns: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    loading: {
      type: Boolean,
      default: false
    },
    empty: {
      type: String,
      default: ''
    },
    bordered: {
      type: Boolean,
      default: false
    },
    dataKey: {
      type: String,
      default: ''
    },
    headerClass: {
      type: String,
      default: ''
    },
    multiple: {
      type: Boolean,
      default: false
    },
    children: {
      type: String,
      default: ''
    },
    tableClass: {
      type: String,
      default: ''
    },
    total: {
      type: [String, Number],
      default: 0
    },
    rows: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    select: {
      type: Boolean,
      default: undefined
    },
    'sticky-header': {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    pages: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    checkAuto: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      isSelect: false,
      checkAll: false,
      checkList: [],
      colspan: 0,
      pageData: {
        pageNum: 1,
        pageSize: 10
      },
      isPages: false
    };
  },
  computed: {
    mini: function mini() {
      return this.$store.state.isAttrCard;
    }
  },
  created: function created() {
    this.isPages = Object.keys(this.$listeners).find(function (item) {
      return item.indexOf('update:pages') != -1;
    });
    if (this.select === false) return;
    var isSelect = Object.keys(this.$listeners).find(function (item) {
      return item.indexOf('select') != -1;
    });
    this.isSelect = !!isSelect;
  },
  mounted: function mounted() {
    var _this = this;
    if (this.$slots['after-header']) {
      this.colspan = this.$slots['after-header'].length;
    }
    this.$nextTick(function () {
      window.addEventListener('resize', _this.setTruncate);
    });
  },
  watch: {
    checkAll: function checkAll() {
      if (this.checkAuto) {
        this.checkClick();
      }
    },
    pages: {
      handler: function handler(val) {
        if (Object.keys(val).length) {
          this.pageData = val;
        }
      },
      immediate: true,
      deep: true
    },
    selected: {
      handler: function handler(val) {
        var _this2 = this;
        var rowsLength = 0;
        this.checkList = val;
        if (this.multiple) {
          this.rows.forEach(function (item) {
            item[_this2.children].forEach(function (ele, i) {
              rowsLength += 1;
            });
          });
        } else {
          rowsLength = this.rows.length;
        }
        if (val.length != rowsLength && val.length != 0) {
          this.checkAll = 'not';
        } else if (rowsLength && val.length === rowsLength) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }
      },
      immediate: true
    },
    checkList: {
      handler: function handler(val) {
        var _this3 = this;
        var rowsLength = 0;
        if (this.multiple) {
          this.rows.forEach(function (item) {
            item[_this3.children].forEach(function (ele, i) {
              rowsLength += 1;
            });
          });
        } else {
          rowsLength = this.rows.length;
        }
        var checkedCount = val.length;
        if (checkedCount > 0 && checkedCount < rowsLength) {
          this.checkAll = 'not';
        } else {
          this.checkAll = checkedCount === rowsLength;
        }
        this.$emit('select', val);
        this.$emit('selectChange', val);
      }
    },
    pageData: {
      handler: function handler(val) {
        this.$emit('update:pages', val);
        this.$emit('pagesChange', val);
      },
      deep: true
    }
  },
  methods: {
    setCheckedList: function setCheckedList(val) {
      this.checkList = val;
    },
    checkClick: function checkClick() {
      var _this4 = this;
      if (this.rows.length == 0) return;
      var val = this.checkAll;
      var arr = [];
      if (this.multiple) {
        this.rows.forEach(function (item) {
          item[_this4.children].forEach(function (ele) {
            arr.push(_this4.dataKey ? ele[_this4.dataKey] : ele);
          });
        });
      } else {
        this.rows.forEach(function (item) {
          arr.push(_this4.dataKey ? item[_this4.dataKey] : item);
        });
      }
      if (val == 'not') return;
      this.checkList = val ? arr : [];
      this.$emit('selectAll', {
        val: val,
        rows: arr
      });
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageData.pageNum = val;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageData.pageSize = val;
    },
    setTruncate: debounce(function () {
      var _this5 = this;
      this.$nextTick(function () {
        if (_this5.$refs.truncate && _this5.$refs.truncate.length) {
          _this5.$refs.truncate.forEach(function (item) {
            item.getItem();
          });
        }
      });
    }, 300),
    /**
     * 判断变量是否等于或存在于另一个变量中
     */
    isEqualOrContains: function isEqualOrContains(var1, var2) {
      if (var1 === var2) {
        return true;
      }
      try {
        if (typeof var2.includes === 'function') {
          return var2.includes(var1);
        }
      } catch (error) {
        // 忽略类型错误
      }
      return false;
    }
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.setTruncate);
  }
};